/* eslint-disable object-curly-newline */
import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {},
        btnContainer: {
            display: 'flex',
            justifyContent: 'right',
            paddingTop: theme.spacing(1),
        },
        gridContainer: {
            margin: '0 !important',
        },
        header: {
            padding: '0 !important',
        },
        btn: {
            backgroundColor: 'transparent',
            border: 0,
            letterSpacing: 0,
            color: theme.palette.primary[500],
            textTransform: 'uppercase',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'end',
            fontSize: '14px',
            lineHeight: '24px',
            fontWeight: 500,
            padding: 0,
            cursor: 'pointer',
        },
        removeHeaderFiller: {
            width: '24px',
        },
        btnDisabled: {
            cursor: 'not-allowed',
            color: theme.palette.secondary[400],
        },
        addIcon: {
            color: theme.palette.primary[500],
        },
        addIconDisabled: {
            color: theme.palette.secondary[400],
        },
        label: {},
        rightAlign: {
            textAlign: 'right',
            paddingRight: theme.spacing(1),
        },
        disabledLabel: {
            paddingRight: 0,
        },
    }
})

export default useStyles
